<template>
  <div v-if="internalValue!==undefined" class="color-opacity-wrapp">
    <div class="title">{{ $t('transparency') }}</div>
    <div class="slider-wrapper">
      <VueSlider 
        v-model="internalValue"
        :min="0"
        :max="100"
        :style="{ padding: '0'}"
        :process-style="{ backgroundColor: 'black' }"
        :tooltip-style="{ backgroundColor: 'black', borderColor: 'black' }"
        :dot-style="{ backgroundColor: 'black', borderColor: 'black', boxShadow: '0.5px 0.5px 2px 1px rgb(0 0 0 / 32%)' }"
      />
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'

export default {
  components: {
    VueSlider,
  },
  model: {
    prop: 'config',
    event: 'change-opacity',
  },
  props: {
    config: [Number],
  },
  computed: {
    internalValue: {
      get() {
        return this.config
      },
      set(value) {
        this.$emit('change-opacity', value)
      },
    },
  },
  methods: {},
}
</script>

<style lang="stylus" scoped>
.color-opacity-wrapp
  margin-bottom: vw(20px)

  .title
    m-font-size(14, 20)
    margin-bottom: vw(10px)
    font-weight: 600

  .slider-wrapper
    margin-top: vw(25px)
</style>
